import {SET_REPURPOSED_FLAG} from "./dispatchTypes";

export const setRepurposedFlag = (repurposed) => async (dispatch) => {
    dispatch({
        type: SET_REPURPOSED_FLAG,
        payload: {
            repurposed: repurposed
        }
    })
}